<div class="main-layout">
  <!-- Toast for notifications -->
  <p-toast position="top-right" ></p-toast>

  <!-- Header -->
  <app-header (loginClicked)="onLoginClicked()" (signupClicked)="onSignupClicked()">
  </app-header>

  <!-- Main Content Area -->
  <main class="content-area">
    <div class="login-container p-d-flex p-ai-center p-jc-center p-p-3 p-px-3">
      <div class="form-section p-w-100 p-mx-auto" style="max-width: 654px; min-height: 808px">
        <div class="form-card p-w-100 p-h-100 p-bg-white p-border-round p-shadow-4 p-d-flex p-ai-center">
          <div
            class="form-content p-w-100 p-mx-auto p-d-flex p-flex-column p-jc-center p-ai-center p-gap-4 p-py-6 p-px-3"
            style="max-width: 399px">
            <!-- Header Section -->
            <div class="form-header p-d-flex p-flex-column p-jc-center p-ai-center p-gap-3 p-w-100"
              style="max-width: 338px">
              <h1 class="welcome-title p-text-center">
                welcome back to showlab.
              </h1>
              <p class="welcome-subtitle p-text-center">
                start creating in your lab.
              </p>
            </div>

            <!-- Form Section -->
            <div class="form-body p-w-100" style="max-width: 399px">
              <form class="login-form p-d-flex p-flex-column p-w-100" (ngSubmit)="onSubmit()" #loginForm="ngForm">
                <div class="fields p-w-100 p-gap-2 p-px-3">
                  <div class="form-fields p-d-flex p-flex-column p-w-100 p-gap-2 p-px-2">
                    <!-- Email Field -->
                    <div class="form-field p-d-flex p-flex-column p-gap-1">
                      <label for="email"><strong>email</strong></label>
                      <input pInputText type="email" id="email" name="email" placeholder="enter email"
                        [(ngModel)]="loginData.email" required
                        pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$" #emailField="ngModel"
                        class="form-input p-w-100 p-border-round" [ngClass]="{
                          'ng-invalid':
                            emailField.errors &&
                            (emailField.dirty ||
                              emailField.touched ||
                              formSubmitted)
                        }" />
                      @if (emailField.errors && (emailField.dirty ||
                      emailField.touched || formSubmitted)) {
                      <div class="alert alert-danger">
                        @if (emailField.errors['required']) {
                        <div class="text-red">email is required!</div>
                        } @if (emailField.errors['pattern']) {
                        <div class="text-red">
                          please enter a valid email address!
                        </div>
                        }
                      </div>
                      }
                    </div>

                    <!-- Password Field -->
                    <!-- <div class="form-field p-d-flex p-flex-column p-gap-1">
                      <label for="password"><strong>password</strong></label>
                      <input
                        pInputText
                        type="password"
                        id="password"
                        name="password"
                        placeholder="enter password"
                        [(ngModel)]="loginData.password"
                        required
                        minlength="8"
                        #passwordField="ngModel"
                        class="form-input p-w-100 p-border-round"
                        [ngClass]="{
                          'ng-invalid':
                            passwordField.errors &&
                            (passwordField.dirty ||
                              passwordField.touched ||
                              formSubmitted)
                        }"
                      />
                      @if (passwordField.errors && (passwordField.dirty ||
                      passwordField.touched || formSubmitted)) {
                      <div class="alert alert-danger">
                        @if (passwordField.errors['required']) {
                        <div class="text-red">Password is required!</div>
                        } @if (passwordField.errors['minlength']) {
                        <div class="text-red">
                          Password must be at least 8 characters long!
                        </div>
                        }
                      </div>
                      }
                    </div> -->
                    <!-- Password Field with Eye Icon -->
                    <div class="form-field p-d-flex p-flex-column p-gap-1">
                      <label for="password"><strong>password</strong></label>
                      <div class="password-input-wrapper">
                        <input pInputText [type]="showPassword ? 'text' : 'password'" id="password" name="password"
                          placeholder="enter password" [(ngModel)]="loginData.password" required minlength="8"
                          #passwordField="ngModel" class="form-input p-w-100 p-border-round" [ngClass]="{
        'ng-invalid':
          passwordField.errors &&
          (passwordField.dirty ||
            passwordField.touched ||
            formSubmitted)
      }" />
                        <span class="password-toggle-icon" (click)="togglePasswordVisibility()">
                          <i [class]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
                        </span>
                      </div>
                      @if (passwordField.errors && (passwordField.dirty ||
                      passwordField.touched || formSubmitted)) {
                      <div class="alert alert-danger">
                        @if (passwordField.errors['required']) {
                        <div class="text-red">password is required!</div>
                        } @if (passwordField.errors['minlength']) {
                        <div class="text-red">
                          password must be at least 8 characters long!
                        </div>
                        }
                      </div>
                      }
                    </div>
                  </div>
                </div>

                <!-- Form Actions -->
                <div class="form-actions p-d-flex p-flex-column p-ai-center p-gap-2 p-px-3">
                  <div class="forgot-text p-w-100 p-text-center p-p-2">
                    <a href="#" class="forgot-password" (click)="
                        navigateToForgotPassword(); $event.preventDefault()
                      ">forgot password</a>
                  </div>
                  <div class="action-buttons p-d-flex p-flex-column p-ai-center p-w-100 p-gap-2 p-px-2">
                    <button pButton type="submit" class="btn-signup-form p-w-100 p-border-round"
                      [disabled]="!loginForm.form.valid">
                      sign in
                    </button>
                    <div class="login-txt p-w-100 p-text-center p-p-2">
                      <p class="login-text clickable" (click)="navigateToSignUp()">
                        don't have an account?
                      </p>
                    </div>
                    <!-- <div class="or-txt p-w-100 p-text-center p-p-2">
                      <p class="or-text">OR</p>
                    </div> -->
                  </div>
                </div>
              </form>
            </div>

            <!-- Social Login Section -->
            <!-- <div class="social-login p-d-flex p-jc-center p-ai-center p-w-100 p-gap-3 p-px-3" style="max-width: 399px;">
              <div class="social-buttons p-d-flex p-jc-between p-ai-center p-w-100 p-gap-3 p-px-2">
                <button pButton class="social-btn p-border-round" (click)="loginWithApple()" aria-label="Login with Apple">
                  <img src="assets/icons/mac_icon.png" alt="Apple" />
                </button>
                <button pButton class="social-btn p-border-round" (click)="loginWithGoogle()"
                  aria-label="Login with Google">
                  <img src="assets/icons/google_icon.png" alt="Google" />
                </button>
                <button pButton class="social-btn p-border-round" (click)="loginWithFacebook()"
                  aria-label="Login with Facebook">
                  <img src="assets/icons/fb_icon.png" alt="Facebook" />
                </button>
                <button pButton class="social-btn p-border-round" (click)="loginWithEmail()" aria-label="Login with Email">
                  <img src="assets/icons/email_icon.png" alt="Email" />
                </button>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </main>
  <app-footer></app-footer>
</div>
<p-dialog [(visible)]="messagePopupVisible" [modal]="true" [closable]="false" [dismissableMask]="false"
  [showHeader]="false" styleClass="custom-confirm-dialog">
  <div class="message-selection">
    <div class="logo-container">
      <img class="logo-img" src="assets/icons/logo.png" alt="logo" />
    </div>
    <div style="display: flex">
      <i class="pi pi-chevron-left chevron-left" style="padding: 10px" (click)="closePopup()"
        style="cursor: pointer; padding: 10px"></i>
      <h3 class="styled-text">oops! having trouble signing in?</h3>
    </div>
    <div class="sub-question">
      don't have an account? <span class="get-started">get started</span>
    </div>
    <div class="message-options">
      <div class="textarea-container">
        <input id="email" class="input-field" pInputText placeholder="Email" [(ngModel)]="loginData.email" />
      </div>
    </div>
    <div style="display: flex; justify-content: center; ">
      <button class="send-btn" (click)="Continue()">continue</button>
    </div>
  </div>
</p-dialog>